import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie'

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(false);
  const [loading, setLoading] = useState(true);
  const csrftoken = Cookies.get('csrftoken') // Cookies from Django Domain
 

  useEffect(() => {
    if (localStorage.getItem('token') !== null) {
      window.location.replace('/app/');
    } else {
      setLoading(false);
    }
  }, []);

    const onSubmit = e => {
        e.preventDefault();

        const user = {
            email: email,
            password: password
        };


        fetch('/api/users/auth/login/', {
            method: 'POST',
            headers: {
            //  csrfmiddlewaretoken: csrftoken,
              'X-CSRFToken': csrftoken,
              'Content-Type': 'application/json'


            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                if (data.key) {
                    localStorage.clear();
                    localStorage.setItem('token', data.key);
                    localStorage.setItem('csrftoken', csrftoken);
                    localStorage.setItem('user', data.user);
                    localStorage.setItem('firstName', data.firstName);
                    localStorage.setItem('colId', data.colId);
                    localStorage.setItem('emailConfirmed', data.emailConfirmed);
                    window.location.replace('/app/');
                } else {
                    setEmail('');
                    setPassword('');
                    localStorage.clear();
                    setErrors(true);
                }
            });
       
    };
  
  return (
    <div className="card card-body mt-4 mb-4">
      {loading === false && <h3>Login</h3>}
      {errors === true && <h4>Cannot log in with provided credentials</h4>}
      {loading === false && (
        <form onSubmit={onSubmit}>
          <label htmlFor='email'>Email address:</label> <br />
          <input
            name='email'
            type='email'
            value={email}
            required
            onChange={e => setEmail(e.target.value)}
          />{' '}
          <br />
          <label htmlFor='password'>Password:</label> <br />
          <input
            name='password'
            type='password'
            value={password}
            required
            onChange={e => setPassword(e.target.value)}
          />{' '}
          <br />
          <button type="submit" 
                            className="btn btn-primary m-2">
                            Submit
            </button>
        </form>
      )}
    </div>
  );
};

export default Login;